import { render } from "./AgentShipments.vue?vue&type=template&id=11baa871"
import script from "./AgentShipments.vue?vue&type=script&lang=ts"
export * from "./AgentShipments.vue?vue&type=script&lang=ts"
script.render = render

export default script